import {RefObject, useRef, useState } from "react";

export interface IArrangementPreviewButtonLogic {
  audioRef: RefObject<HTMLAudioElement>,
  isPreviewPlaying: boolean,
  toggleAudio: () => void,
  resetAudioPreview: () => void,
}

export const useArrangementPreviewButtonLogic = (): IArrangementPreviewButtonLogic => {
  const audioRef = useRef<HTMLAudioElement>(document.createElement('audio'));
  const [isPreviewPlaying, setPreviewPlaybackState] = useState<boolean>(false);
  const toggleAudio = () => {
    if (audioRef.current.paused) {
      audioRef.current.play();
      setPreviewPlaybackState(true);
    } else {
      audioRef.current.pause();
      setPreviewPlaybackState(false);
    }
  }

  const resetAudioPreview = () => {
    setPreviewPlaybackState(false);
  }

  return {audioRef, isPreviewPlaying, toggleAudio, resetAudioPreview};
}
